import { colors } from "../../common/colors";

export const mngStyles = {
  adminUserDialogTitle: {
    fontWeight: "400",
    color: colors.farm_blue200,
    // textAlign: "center",
  },

  adminUserDialogContent: {
    alignItems: "center",
    justifyContent: "center",
    alignContent: "center",
    display: "flex",
    // flexDirection: "column",
  },

  desTable: { fontWeight: "300" },

  titletable: { color: colors.farm_blue200, fontWeight: "600" },

  tableTitleUser: {
    fontSize: 20,
    alignSelf: "center",
    marginBottom: 30,
    fontWeight: "600",
    color: colors.farm_blue200,
  }
}